import React from "react";
import ReviewsCard from "../../technicalSupport/reviews/reviewsCard";
import { getReviews } from "../../../MyApi/reviews";
import { useQuery } from "react-query";

const ProductReviews = ({ productId }) => {
  const { data, isLoading, error, refetch } = useQuery(
    ["getReviewsUsers", productId],
    () => getReviews("", "", productId)
  );
  const reviews = data?.data.reviews || [];
  return (
    <div className="card rounded-3">
      <div className="card-body">
        <h6 className="mb-3">التقييمات</h6>
        <div className="row">
          {reviews.length > 0 ? (
            reviews.map((review) => (
              <div key={review.id} className="col-12  mb-4">
                <ReviewsCard review={review} refetch={refetch} />
              </div>
            ))
          ) : (
            <div className="col-12">
              <div className="text-center py-5">
                <p className="text-muted">لا توجد تقييمات متاحة</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductReviews;
